import styled from 'styled-components';

export const Container = styled.div`
  max-height: calc(100vh - 200px);
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  
  /* Customização da scrollbar */
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
`;



export const InfoSection = styled.div`
  background-color: #f8f9fa;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 24px;
  border: 1px solid #e9ecef;
  max-height: 400px;
  overflow-y: auto;
  
  /* Customização da scrollbar */
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
`;

export const InfoBlock = styled.div`
  margin-bottom: 20px;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

export const SectionTitle = styled.h3`
  margin: 0 0 16px 0;
  font-size: 16px;
  font-weight: 600;
  color: #495057;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 12px;
`;

export const InfoCard = styled.div<{ fullWidth?: boolean }>`
  background-color: white;
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid #dee2e6;
  ${props => props.fullWidth && 'grid-column: 1 / -1;'}
`;

export const InfoLabel = styled.span`
  font-size: 12px;
  color: #6c757d;
  font-weight: 500;
  display: block;
`;

export const InfoValue = styled.div<{
  color?: 'success' | 'warning' | 'danger' | 'default';
  size?: 'sm' | 'md' | 'lg';
}>`
  font-size: ${props => {
    switch (props.size) {
      case 'sm': return '14px';
      case 'lg': return '16px';
      default: return '14px';
    }
  }};
  font-weight: ${props => props.size === 'lg' ? '700' : '600'};
  color: ${props => {
    switch (props.color) {
      case 'success': return '#28a745';
      case 'warning': return '#fd7e14';
      case 'danger': return '#dc3545';
      default: return '#212529';
    }
  }};
  margin-top: 4px;
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const ComprovanteContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 5px 0;
  margin-top: auto;
`;

export const ComprovanteButton = styled.button`
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  border: none;
  border-radius: 12px;
  padding: 16px 32px;
  font-size: 16px;
  font-weight: 600;
  color: white;
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: center;
  cursor: pointer;
  min-width: 200px;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(40, 167, 69, 0.4);
  }
  
  &:active {
    transform: translateY(0);
  }
  
  &:disabled {
    background: #6c757d;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }
`;

export const AvisoContainer = styled.div`
  margin-bottom: 24px;
  padding: 20px;
  border: 2px solid #ffc107;
  border-radius: 12px;
  background-color: #fff3cd;
  text-align: center;
`;

export const AvisoTitle = styled.h4`
  color: #856404;
  margin-bottom: 12px;
  font-size: 16px;
  font-weight: 600;
`;

export const AvisoText = styled.p`
  color: #856404;
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
`;

